"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTalentAudioUI = exports.updateLocalAudioUI = exports.setupUI = void 0;
const plyr_1 = __importDefault(require("plyr"));
function setupPlyr() {
    const noControls = {
        clickToPlay: false,
        ratio: '16:9',
        storage: { enabled: false },
        captions: { active: true },
        keyboard: { focused: false, global: false },
        volume: 1,
        controls: [
            'captions', // Toggle captions
            // 'fullscreen', // Toggle fullscreen
        ],
    };
    // @Anywhere
    const withVolume = noControls;
    withVolume.controls.push('mute', 'volume');
    withVolume.volume = 0.5;
    plyr_1.default.setup('.volumeControls', withVolume);
    // @Anywhere
    const promoControls = noControls;
    promoControls.controls = [
        'play', // Play/pause playback
        'progress', // The progress bar and scrubber for playback and buffering
        'fullscreen', // Toggle fullscreen
    ];
    plyr_1.default.setup('.promoVideo', promoControls);
}
let manager;
let talentAudioEnabled = true;
let localAudioEnabled = true;
function setupUI(_manager) {
    manager = _manager;
    setupPlyr();
    document.querySelectorAll(".microphoneToggle").forEach((microphoneToggle) => {
        microphoneToggle.addEventListener('click', handleMicrophoneToggle);
    });
}
exports.setupUI = setupUI;
function handleMicrophoneToggle(event) {
    if (this.dataset.id === 'microphone') {
        localAudioEnabled = !localAudioEnabled;
        manager.toggleLocalAudio(localAudioEnabled);
    }
    if (this.dataset.id === 'talent') {
        talentAudioEnabled = !talentAudioEnabled;
        manager.toggleTalentAudio(talentAudioEnabled);
    }
}
function updateLocalAudioUI(enabled) {
    const PTT_BUTTON = '.ptt';
    document.querySelectorAll(PTT_BUTTON).forEach((button) => {
        button.classList.toggle('speaking', enabled);
    });
    const muteButtonAll = document.querySelectorAll(".muteMicrophone[data-id='microphone']");
    muteButtonAll.forEach((muteButton) => {
        let input = muteButton.querySelector('input');
        if (input) {
            setCheckbox(input, enabled);
        }
    });
}
exports.updateLocalAudioUI = updateLocalAudioUI;
function setCheckbox(el, enabled) {
    el.checked = enabled;
    el.setAttribute('aria-checked', enabled.toString());
    el.setAttribute('checked', enabled.toString());
}
function updateTalentAudioUI(enabled) {
    const muteButton = document.querySelector(".microphoneToggle[data-id='talent']");
    let input = muteButton === null || muteButton === void 0 ? void 0 : muteButton.querySelector('input');
    if (input) {
        setCheckbox(input, enabled);
    }
}
exports.updateTalentAudioUI = updateTalentAudioUI;
